import { listenerAtom } from '@src/atoms/listenerAtom';
import { socketAtom } from '@src/atoms/socket';
import { useAtomValue } from '@zedux/react';
import React from 'react';

export const Listener: React.FC = () => {
    const socket = useAtomValue(socketAtom)
    const listener = useAtomValue(listenerAtom)

    return null;
}
